import axiosLC, { LOGIN_OAUTH2 } from "services";

export const getAccessToken = async () => {
  const resultLogin = await axiosLC.post(LOGIN_OAUTH2, null, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    auth: {
      username: process.env.REACT_APP_API_KEY_ID ?? "",
      password: process.env.REACT_APP_API_KEY ?? "",
    },
  });
  const token = resultLogin.data.access_token;
  return token;
};
